import $ from "jquery";

(function ($) {

  function fixedMenu()
  {
    if ($('.js-page-overview-widget').length)
    {
      var element = $(".js-page-overview-widget");
      var element_height = element.height();
      var element_top = element.offset().top;

      if ($(window).width() > 1024)
      {
        $(window).scroll(function()
        {

          // console.clear();
          var scrollTop = $(window).scrollTop();

          if ($(window).scrollTop() >= (element_top + element_height))
          {
            $(".fixed-navigation").addClass("show");
          }
          else
          {
            $(".fixed-navigation").removeClass("show");
          }

        });
      }

    }
  }


  function relatedReadingPosition()
  {
    var $relatedWidget = $('.related-readings-widget');

    if ($relatedWidget.length)
    {
      var relatedReadingsHeight = $relatedWidget.outerHeight(),
        articleHeight = $('.single .article-content').outerHeight(),
        widgetsHeight = $('.single .widgets').outerHeight();

      if (articleHeight > (widgetsHeight * 1.5))
      {
        $relatedWidget.addClass('positioned');
      }
    }
  }

  function truncate(string)
  {
    if (!string)
    {
      return;
    }
    if (string.length > 30)
    {
      return string.substring(0, 30) + '...';
    }
    else
    {
      return string;
    }
  };

  $(window).ready(function () {

    //	ARTICLE / JOURNAL OVERVIEW WIDGET
    if ($('.single-page').length) {
      var menu_headers = "";
      var article_headers = "";
      var ctr = 0;
      if (!$('[data-block-type="header"] h2').length)
      {
        return;
      }

      $('[data-block-type="header"] h2').each(function()
      {
        var title = $(this).html();
        ctr++;

        article_headers += "<a href='#" + title + "' class='page-header d-table title'>" +
          "<div class='d-table-cell align-top'>" +
          "<div class='number'>" + ctr + "</div>" +
          "</div>" +
          "<div class='d-table-cell align-top'>" +
          "<p class='small'>" + title + "</p>" +
          "</div>" +
          "</a>";

        menu_headers += "<li>" +
          "<a href='#" + title + "' class='btn-style-2 d-table'>" +
          "<div class='d-table-cell align-middle'>" + truncate(title) + "</div>" +
          "</a>" +
          "</li>";

      });

      $(".overview-headers").html(article_headers);
      $(".fixed-navigation ul").html(menu_headers);

      $(".fixed-navigation ul li").each(function()
      {
        $(this).find(".btn-style-2").click(function()
        {
          $(".fixed-navigation ul li").removeClass("active");
          $(this).parent("li").addClass("active");
        });
      });

      fixedMenu();
      relatedReadingPosition();
    }

    //	DEFAULT TEMPLATE OVERVIEW WIDGET
    if ($("body").hasClass("page-template-default")) {


      var menu_headers = "";
      var headers = "";
      var ctr = 0;

      $('[data-block-type="header"] h2').each(function()
      {
        var title = $(this).html();
        ctr++;

        headers += "<a href='#" + title + "' class='page-header d-table title'>" +
          "<div class='d-table-cell align-top'>" +
          "<div class='number'>" + ctr + "</div>" +
          "</div>" +
          "<div class='d-table-cell align-top'>" +
          "<p class='small'>" + title + "</p>" +
          "</div>" +
          "</a>";

        menu_headers += "<li>" +
          "<a href='#" + title + "' class='btn-style-2 d-table'>" +
          "<div class='d-table-cell align-middle'>" + truncate(title) + "</div>" +
          "</a>" +
          "</li>";

      });

      $(".overview-headers").html(headers);
      $(".fixed-navigation ul").html(menu_headers);

      $(".fixed-navigation ul li").each(function()
      {
        $(this).find(".btn-style-2").click(function()
        {
          $(".fixed-navigation ul li").removeClass("active");
          $(this).parent("li").addClass("active");
        });
      });

      fixedMenu();
      relatedReadingPosition();
    }

    //	LANDING TEMPLATE 2 OVERVIEW WIDGET
    if ($('.template-landing-level-2').length)
    {


      var menu_headers = "";
      var article_headers = "";
      var ctr = 0;

      $(".landing_2_module").each(function()
      {
        // SET HEADER OF TWO COLUMN WITH IMAGE MODULE
        if ($(this).find(".two-column-module").length !== 0)
        {
          var title = $(this).find(".two-column-module h2").html();
          var icon = $(this).find(".two-column-module .icon").css("background-image");
          ctr++;
          var iconElement = icon ? "<div class='icon' style='background-image: " + icon + ";'></div>" : '' ;

          article_headers += "<a href='#" + title + "' class='page-header d-table title'>" +
            "<div class='d-table-cell align-top'>" +
            "<div class='number'>" + ctr + "</div>" +
            "</div>" +
            "<div class='d-table-cell align-top'>" +
            "<p class='small'>" + title + "</p>" +
            "</div>" +
            "</a>";

          menu_headers += "<li>" +
            "<a href='#" + title + "' class='btn-style-2 d-table'>" +
            "<div class='d-table-cell align-middle'>" +
            iconElement +
            "</div>" +
            "<div class='d-table-cell align-middle'>" + truncate(title) + "</div>" +
            "</a>" +
            "</li>";
        }

        // SET HEADER OF TEXT BLOCK WITH LISTING MODULE
        if ($(this).find(".text-block-with-listing-module").length !== 0)
        {
          var title = $(this).find(".text-block-with-listing-module h2").html();

          var icon = $(this).find(".text-block-with-listing-module .left-indent .icon").css("background-image");
          var iconElement = icon ? "<div class='icon' style='background-image: " + icon + ";'></div>" : '' ;
          ctr++;
          article_headers += "<a href='#" + title + "' class='page-header d-table title'>" +
            "<div class='d-table-cell align-top'>" +
            "<div class='number'>" + ctr + "</div>" +
            "</div>" +
            "<div class='d-table-cell align-top'>" +
            "<p class='small'>" + title + "</p>" +
            "</div>" +
            "</a>";

          menu_headers += "<li>" +
            "<a href='#" + title + "' class='btn-style-2 d-table'>" +
            "<div class='d-table-cell align-middle'>" +
            iconElement +
            "</div>" +
            "<div class='d-table-cell align-middle'>" + truncate(title) + "</div>" +
            "</a>" +
            "</li>";
        }

        // SET HEADER OF THREE COLUMN POST OVERVIEW MODULE
        if ($(this).find(".three-column-module").length !== 0)
        {
          var title = $(this).find(".three-column-module .js-three-column-module__heading").html();
          var icon = $(this).find(".three-column-module .icon").css("background-image");
          var iconElement = icon ? "<div class='icon' style='background-image: " + icon + ";'></div>" : '' ;
          ctr++;
          article_headers += "<a href='#" + title + "' class='page-header d-table title'>" +
            "<div class='d-table-cell align-top'>" +
            "<div class='number'>" + ctr + "</div>" +
            "</div>" +
            "<div class='d-table-cell align-top'>" +
            "<p class='small'>" + title + "</p>" +
            "</div>" +
            "</a>";

          menu_headers += "<li>" +
            "<a href='#" + title + "' class='btn-style-2 d-table'>" +
            "<div class='d-table-cell align-middle'>" +
            iconElement+
            "</div>" +
            "<div class='d-table-cell align-middle'>" + truncate(title) + "</div>" +
            "</a>" +
            "</li>";
        }

        $(".overview-headers").html(article_headers);
        $(".fixed-navigation ul").html(menu_headers);
      });

      $(".fixed-navigation ul li").each(function()
      {
        $(this).find(".btn-style-2").click(function()
        {
          $(".fixed-navigation ul li").removeClass("active");
          $(this).parent("li").addClass("active");
        });
      });

      fixedMenu();
    }

  });

})(jQuery);